
import Event from './Event';
import Events from './Events';
import { BaseFocusEvent } from './types';

export default class FocusEvent extends Event {
    public data: BaseFocusEvent;

    constructor(data: BaseFocusEvent) {
        super(Events.Focus);
        this.data = data;
    }
}
